var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.4999V8.4999C20.9996 8.14918 20.9071 7.80471 20.7315 7.50106C20.556 7.19742 20.3037 6.94526 20 6.7699L13 2.7699C12.696 2.59437 12.3511 2.50195 12 2.50195C11.6489 2.50195 11.304 2.59437 11 2.7699L4 6.7699C3.69626 6.94526 3.44398 7.19742 3.26846 7.50106C3.09294 7.80471 3.00036 8.14918 3 8.4999V16.4999C3.00036 16.8506 3.09294 17.1951 3.26846 17.4987C3.44398 17.8024 3.69626 18.0545 4 18.2299L11 22.2299C11.304 22.4054 11.6489 22.4979 12 22.4979C12.3511 22.4979 12.696 22.4054 13 22.2299L20 18.2299C20.3037 18.0545 20.556 17.8024 20.7315 17.4987C20.9071 17.1951 20.9996 16.8506 21 16.4999Z",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27002 7.45996L12 12.51L20.73 7.45996",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.58V12.5",
    stroke: "#DDDEE0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModel);
export default __webpack_public_path__ + "static/media/model.97e129120a6d3b3c8c1feb7ee277c333.svg";
export { ForwardRef as ReactComponent };